import Instance from "../../../../Axios";

// New Actions for the app

const GetWorkPermitsSendContacts = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/workpermits/sendContacts`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_WORK_PERMIT_SEND_CONTACTS", payload: data.yData });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetWorkPermitsSendContacts;
